var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite-projects"},[(_vm.empty)?_c('div',{staticClass:"section-title-desc section-title-desc-favorite"},[_c('h2',[_vm._v("В избранном 0 жилых комплексов")])]):_vm._e(),_c('salesFilter'),_c('salesItems')],1)}
var staticRenderFns = []

export { render, staticRenderFns }